function wcInitReveal() {
  var els = document.querySelectorAll('.wc-reveal:not(.wc-visible)');
  if (!els.length) return;
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) {
    els.forEach(function (el) { el.classList.add('wc-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('wc-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el, i) {
    el.style.setProperty('--wc-delay', (i % 6) * 0.08 + 's');
    observer.observe(el);
  });
}

function wcInitGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-wc-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-wc-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-wc-miniatura]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var full = mini.getAttribute('data-full');
        if (!full) return;
        principal.src = full;
        minis.forEach(function (m) { m.classList.remove('wc-activa'); });
        mini.classList.add('wc-activa');
      });
    });
  });
}

function wcInitOpcionesProducto() {
  var forms = document.querySelectorAll('[data-wc-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-wc-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var contenedor = form.closest('.wc-producto__grid') || document;
    var idInput = form.querySelector('input[name="id"]');
    var precioEl = contenedor.querySelector('[data-wc-precio-actual]');
    var precioAntesEl = contenedor.querySelector('[data-wc-precio-antes]');
    var boton = form.querySelector('[data-wc-agregar]');
    var agotadoEl = form.querySelector('[data-wc-agotado]');
    var grupos = form.querySelectorAll('[data-wc-opcion-grupo]');
    var seleccion = {};

    grupos.forEach(function (grupo) {
      var nombre = grupo.getAttribute('data-wc-opcion-grupo');
      var activo = grupo.querySelector('.wc-activa');
      if (activo) seleccion[nombre] = activo.getAttribute('data-valor');
    });

    function actualizar() {
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) {
          var nombreOpcion = Object.keys(seleccion)[i];
          return true;
        }) && Object.keys(seleccion).every(function (nombre, i) {
          return v.options[i] === seleccion[nombre];
        });
      });
      if (!variante) return;
      idInput.value = variante.id;
      if (precioEl) precioEl.textContent = variante.price_formatted;
      if (precioAntesEl) {
        if (variante.compare_at_price_formatted) {
          precioAntesEl.textContent = variante.compare_at_price_formatted;
          precioAntesEl.style.display = '';
        } else {
          precioAntesEl.style.display = 'none';
        }
      }
      if (boton) boton.disabled = !variante.available;
      if (agotadoEl) agotadoEl.style.display = variante.available ? 'none' : 'block';
    }

    grupos.forEach(function (grupo) {
      var nombre = grupo.getAttribute('data-wc-opcion-grupo');
      var valores = grupo.querySelectorAll('[data-valor]');
      valores.forEach(function (valor) {
        valor.addEventListener('click', function () {
          valores.forEach(function (v) { v.classList.remove('wc-activa'); });
          valor.classList.add('wc-activa');
          seleccion[nombre] = valor.getAttribute('data-valor');
          actualizar();
        });
      });
    });
  });
}

function wcInitVideoTestimonios() {
  var items = document.querySelectorAll('[data-wc-video-item]');
  items.forEach(function (item) {
    var video = item.querySelector('[data-wc-video]');
    var boton = item.querySelector('[data-wc-boton-sonido]');
    var iconoMuted = item.querySelector('[data-wc-icono-muted]');
    var iconoSonido = item.querySelector('[data-wc-icono-sonido]');
    if (!video || !boton) return;
    boton.addEventListener('click', function (e) {
      e.stopPropagation();
      items.forEach(function (otro) {
        if (otro === item) return;
        var v = otro.querySelector('[data-wc-video]');
        if (v) v.muted = true;
        var im = otro.querySelector('[data-wc-icono-muted]');
        var is = otro.querySelector('[data-wc-icono-sonido]');
        if (im) im.style.display = '';
        if (is) is.style.display = 'none';
      });
      video.muted = !video.muted;
      if (iconoMuted) iconoMuted.style.display = video.muted ? '' : 'none';
      if (iconoSonido) iconoSonido.style.display = video.muted ? 'none' : '';
    });
  });
}

function wcInitResenasArrastre() {
  var tracks = document.querySelectorAll('[data-wc-resenas-track]');
  tracks.forEach(function (track) {
    var isDown = false;
    var startX, scrollLeft;
    track.addEventListener('mousedown', function (e) {
      isDown = true;
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });
    ['mouseleave', 'mouseup'].forEach(function (evt) {
      track.addEventListener(evt, function () { isDown = false; });
    });
    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      var walk = (x - startX) * 1.2;
      track.scrollLeft = scrollLeft - walk;
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  wcInitReveal();
  wcInitGaleriaProducto();
  wcInitOpcionesProducto();
  wcInitVideoTestimonios();
  wcInitResenasArrastre();
});
